// The route line, shrunk to a mark. The logo is the product's one idea.
export default function Brand({ className = '' }) {
  return (
    <span className={`flex items-center gap-[7px] ${className}`}>
      <span aria-hidden="true" className="w-[7px] h-[7px] rounded-full bg-brand" />
      <span aria-hidden="true" className="w-4 h-px bg-brand" />
      <span aria-hidden="true" className="w-[7px] h-[7px] rounded-full border-[1.5px] border-brand" />
      <span className="ml-1.5 text-label font-semibold uppercase tracking-[0.14em] text-brand">
        Machi Express
      </span>
    </span>
  )
}
